// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2ksvU","approved":"Status_approved__1PXvM","rejected":"Status_rejected__1ZTdH","expired":"Status_expired__11PN5","label":"Status_label__27krL"};